var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4163 7.33333H13.7497C13.2437 7.33333 12.833 6.92267 12.833 6.41667V2.75",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 11.9167V4.58333C4.58301 3.57042 5.40342 2.75 6.41634 2.75H12.9907C13.4765 2.75 13.9431 2.94342 14.2868 3.28717L16.8792 5.8795C17.2229 6.22325 17.4163 6.68983 17.4163 7.17567V17.4167C17.4163 18.4296 16.5959 19.25 15.583 19.25H11.9163",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39302 17.7729C8.47177 18.6942 6.98035 18.6942 6.0591 17.7729C5.13785 16.8517 5.13785 15.3602 6.0591 14.439C6.98035 13.5177 8.47177 13.5177 9.39302 14.439C10.3134 15.3602 10.3134 16.8535 9.39302 17.7729",
    stroke: "#653494",
    strokeWidth: 1.2857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.0833H13.75",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.917 12.8333H13.7503",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 19.2502L6.05884 17.7734",
    stroke: "#653494",
    strokeWidth: 1.2857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/details-icon.83986f10a86948db34b0b0f4797a6b15.svg";
export { ForwardRef as ReactComponent };